import * as React from 'react';
import { useEffect, useState } from 'react';
import { RingsSpinner } from '@weddingspot/ws-core-components';

import styles from './styles.module.scss';
import { VenueProfileContext } from 'components/venueProfile/context';
import { HOGAN_CONFIG } from 'configs/appconfig';

const socialTableBaseURL = HOGAN_CONFIG.social_tables.csn_integration.base_url;

const WeddingSpaces = () => {
    const [showSection, setShowSection] = useState(false);
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const [STSuccess, setSTSuccess] = useState<boolean>();
    const { csnVenueProfile, csnVenueProfileLoading } = React.useContext(VenueProfileContext);
    const [iframeUrl, setIFrameUrl] = React.useState<string>();
    if (!csnVenueProfile) {
        return <></>;
    }

    function checkForChromeEdgeOperaBrowsers(){
        const userAgent = navigator.userAgent;
        if (userAgent.includes("Opera") || userAgent.includes("OPR") || userAgent.includes("Edg") || userAgent.includes("Chrome")) {
            return true;
        } else {
            return false;
        }
    }

    useEffect(() => {
        if (csnVenueProfile.basicProfile.socialTablesEnabled && csnVenueProfile.basicProfile.socialTablesProviderId) {
            setShowSection(true);

            let iframeUrl = new URL(`${socialTableBaseURL}properties/${csnVenueProfile.basicProfile.socialTablesProviderId}/presentation-layer`);
            iframeUrl.search = 'removeRFI=1&removeFilters=1&removeCheckboxes=1&hideRoomDetails=1&primaryColor=881155&embeddedOnCSN=1';

            let STchecker;
            if(checkForChromeEdgeOperaBrowsers()){
                STchecker = document.createElement('link');
                STchecker.href = iframeUrl.toString();
                STchecker.rel = 'prefetch';
            } else {
                STchecker = document.createElement('script');
                STchecker.type = 'text/javascript';
                STchecker.src = iframeUrl.toString();
            }
            STchecker.onload = () => {
                setSTSuccess(true);
            };
            STchecker.onerror = () => {
                setSTSuccess(false);
                setShowSection(false);
            };
            document.head.append(STchecker);

            setIFrameUrl(iframeUrl.toString());
        }
    }, [csnVenueProfile, csnVenueProfileLoading]);

    return showSection ? (
        <>
            <h2> Wedding Spaces</h2>
            <div className={styles.spacesWrapper}>
                {(!iframeLoaded || STSuccess === undefined) && (
                    <div className={styles.spinnerContainer}>
                        <RingsSpinner animate={true} />
                    </div>
                )}
                <iframe
                    className={styles.iframe}
                    onLoad={() => {
                        setIframeLoaded(true);
                    }}
                    src={iframeUrl}
                />
            </div>
        </>
    ) : (
        <></>
    );
};

export default WeddingSpaces;
